export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12885.e47dc6f1.jpg";